var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 288941"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10980_16113)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "#FF8816"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M26.9022 38.2941C30.5785 38.2413 35.75 35 35.75 35C35.75 35 37.7185 36.0061 39.7717 37.8824C40.7474 38.7739 41.9787 40.1808 42.587 41.1765C44.2464 43.8929 45 49 45 49C45 49 34.3475 54.905 26.9022 55C19.1581 55.0988 8 49 8 49C8 49 9.05608 43.889 10.8152 41.1765C11.4554 40.1894 12.2425 38.7797 13.2283 37.8824C15.2755 36.0186 17.6522 35 17.6522 35C17.6522 35 23.0779 38.3491 26.9022 38.2941Z",
    fill: "#8405DA"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 179",
    cx: 26.5,
    cy: 23.5,
    r: 11.5,
    fill: "#8405DA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10980_16113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3327acdf72ea4862b3f311801f05b0c9.svg";
export { ForwardRef as ReactComponent };